import { render, staticRenderFns } from "./AssociationsEditor.vue?vue&type=template&id=628b76ca&scoped=true"
import script from "./AssociationsEditor.vue?vue&type=script&lang=js"
export * from "./AssociationsEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628b76ca",
  null
  
)

export default component.exports